import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  ALERT, UPDATE_LOCAL_USER,
} from "./types";

import AuthService from "@/services/auth-service";
import {loaded, loading} from "@/actions/loader";

export const register = (phone_number: string, password: string, password_confirmation: string) => (dispatch: (any:any) => void) => {
  loading()(dispatch);
  return AuthService.register(phone_number, password, password_confirmation).then(
    (response: {data: {message: string}}) => {
      dispatch({
        type: REGISTER_SUCCESS,
        payload: { ...response.data },
      });

      dispatch({
        type: LOGIN_SUCCESS,
        payload: { ...response.data },
      });

      dispatch({
        type: ALERT,
        payload: { message: response.data }
      });

      loaded()(dispatch);

      return Promise.resolve();
    },
    (error: {response?: {data?: {message?: string}}, message?: string}) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: ALERT,
        payload: message,
      });

      loaded()(dispatch);

      return Promise.reject();
    }
  );
};

export const login = (phone_number: string, password: string, remember?: boolean) => (dispatch: (any:any) => void) => {
  loading()(dispatch);
  return AuthService.login(phone_number, password, remember || false).then(
    (data: {user: object}) => {

      dispatch({
        type: LOGIN_SUCCESS,
        payload: { ...data },
      });

      dispatch({
        type: ALERT,
        payload: { message: data }
      });

      loaded()(dispatch);

      return Promise.resolve();
    },
    (error: {response?: {data?: {message?: string, user?: any}}, message?: string}) => {
      const message = error.response?.data?.message || error.message || error.toString();
      const user = error.response?.data?.user;

      if(user) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user },
        });          

        loaded()(dispatch);

        return Promise.resolve();
      }
      
      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: ALERT,
        payload: { message: { result: 0, message } }
      });

      loaded()(dispatch);

      return Promise.reject();
    }
  );
};

export const logout = () => (dispatch: (any:any) => void) => {
  // AuthService.logout();
  localStorage.removeItem("user");
  dispatch({
    type: LOGOUT,
  });
};

export const updateLocalUser = () => (dispatch: (any:any) => void) => {
  loading()(dispatch);
  AuthService.updateLocalUser().then(user => {
    dispatch({
      type: UPDATE_LOCAL_USER,
      user
    });
    loaded()(dispatch);
  }).catch(err => {
    const result = err.response.data || { result: 0, message: "خطای نامشخص" };
    dispatch({
      type: ALERT,
      payload: { result: 0, message: result }
    });
    loaded()(dispatch);
  });
};
